import React, { Component } from "react"
import autobind from "class-autobind"
import ToolTip from "react-portal-tooltip"
import { TextField, Dialog, FlatButton, FontIcon, IconButton, Chip } from "material-ui"
import DayPicker, { DateUtils } from "react-day-picker"
import "react-day-picker/lib/style.css"
import { CalendarInput, JobsPerDate } from "./CalendarInput"
import strings from "../../../localization/strings"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import AccountStore from "../../../stores/AccountStore"
import AddShiftTemplateDialog from "../../../components/schedule/add_shift_template/AddShiftTemplateDialog"
import EmployeeChip from "../../../components/employee/EmployeeChip"
import { IClientDocument, IScheduleShift, IMassJobCreation, IUIUser } from "../../../models"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"

interface IProps {
    client: IClientDocument
    handleSaveJob: (job: IMassJobCreation) => void
    closeDialog: () => void
}

interface IState {
    selectedDays: JobsPerDate[]
    selectedDate: Date
    selectedDateJobs: number
    openCalendarInput: boolean
    isEdit: boolean
    jobId: string
    openAddShiftDialog: boolean
    employee: IUIUser
    errorShift: string
    showTooltip: boolean
    note: string
    shifts: IScheduleShift[]
}

export class AddClientJobDialog extends Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedDays: [],
            selectedDate: new Date(),
            selectedDateJobs: 0,
            openCalendarInput: false,
            isEdit: false,
            jobId: null,
            openAddShiftDialog: false,
            employee: null,
            errorShift: "",
            showTooltip: false,
            note: "",
            shifts: []
        }
        autobind(this)
    }

    handleDayClick(date: Date) {
        const isExist = this.state.selectedDays.find((x) => DateUtils.isSameDay(x.Date, date))
        this.setState({
            openCalendarInput: true,
            selectedDate: isExist ? isExist.Date : date,
            selectedDateJobs: isExist ? isExist.NumberOfJobs : 0,
            isEdit: isExist ? true : false,
            jobId: isExist ? isExist.Id : null
        })
    }

    //Edit Case Needs To Be Handled
    //Remove Case Needs To Be Handled
    handleAddJob(input: JobsPerDate) {
        this.setState({ selectedDays: [...this.state.selectedDays, input], openCalendarInput: false })
    }

    handleUpdateJob(input: JobsPerDate) {
        this.setState({ selectedDays: this.state.selectedDays.map((x) => (x.Id === input.Id ? { ...input } : { ...x })), openCalendarInput: false })
    }

    addShiftTemplate(shift: IScheduleShift) {
        this.setState({ shifts: [...this.state.shifts, shift], openAddShiftDialog: false })
    }

    renderDay(date: Date) {
        const day = date.getDate()
        const input = this.state.selectedDays.find((x) => DateUtils.isSameDay(x.Date, date))
        return (
            <div>
                <span>{day}</span>
                {input && <small style={{ color: "gold" }}>{input.NumberOfJobs}</small>}
            </div>
        )
    }

    handleMassJobCreation() {
        if (this.state.shifts.length < 1) return
        else {
            const job: IMassJobCreation = {
                Shifts: this.state.shifts,
                EmployeeId: this.state.employee ? this.state.employee.Id : "",
                Jobs: this.state.selectedDays.map(({ Id, ...rest }) => rest),
                ClientId: this.props.client.Id,
                AccountId: AccountStore.getCurrentAccount().Id,
                Note: this.state.note
            }
            this.props.handleSaveJob(job)
        }
    }

    render() {
        const dateWithMultipleJobsExist = this.state.selectedDays.find((x) => x.NumberOfJobs > 1)
        return (
            <Dialog
                open
                title={checkJobFieldAvailable('singular') ? `Add ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}(s)` : "Add Job(s)"}
                actions={[
                    <FlatButton key="cancel" label={"Cancel"} secondary onTouchTap={this.props.closeDialog} />,
                    <FlatButton key="save" label={"Save"} primary onTouchTap={this.handleMassJobCreation} />
                ]}
                bodyStyle={{ padding: "0 20px", minHeight: 435 }}
            >
                <div style={{ display: "flex" }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "50%", margin: "25px" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div>
                                <h3>{strings.Add_Shift_Template}</h3>
                                <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
                                    {strings.Shift}
                                    {this.state.errorShift && <span style={{ color: "rgb(244, 67, 54)", marginLeft: 10 }}>{"Shift Required"}</span>}
                                </div>
                                {this.state.shifts.map((shift) => (
                                    <span key={shift.Id} style={{ margin: 5 }}>
                                        <Chip
                                            onRequestDelete={() => this.setState({ shifts: this.state.shifts.filter((x) => x !== shift) })}
                                            style={{ display: "inline-block", cursor: "pointer", marginTop: 4, height: 42 }}
                                            labelStyle={{ position: "inherit" }}
                                            deleteIconStyle={{ position: "inherit", top: 8 }}
                                        >
                                            {shift.Name}
                                        </Chip>
                                    </span>
                                ))}

                                {
                                    <IconButton style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }} onTouchTap={() => this.setState({ openAddShiftDialog: true })}>
                                        <FontIcon className="fa fa-plus-circle" />
                                    </IconButton>
                                }
                            </div>
                            <div>
                                <h3>{strings.ADD_EMPLOYEE}</h3>
                                <div style={{ marginTop: -5, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    <span
                                        id={"employeeTooltip"}
                                        onClick={() => this.setState({ showTooltip: dateWithMultipleJobsExist ? true : false })}
                                        onMouseOut={() => this.setState({ showTooltip: false })}
                                    >
                                        {!dateWithMultipleJobsExist ? (
                                            <EmployeeChip
                                                errEmployee={false}
                                                setEmployee={(employee) => this.setState({ employee })}
                                                filterByLevel={true}
                                                selectedEmployee={this.state.employee}
                                            />
                                        ) : (
                                            <IconButton style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}>
                                                <FontIcon className="fa fa-plus-circle" />
                                            </IconButton>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: "auto" }}>
                            <TextField fullWidth multiLine rows={3} rowsMax={4} floatingLabelText={strings.Note} value={this.state.note} onChange={(e, value) => this.setState({ note: value })} />
                        </div>
                    </div>
                    <div style={{ width: "50%" }}>
                        <DayPicker
                            containerProps={{ style: { width: "100%" } }}
                            selectedDays={this.state.selectedDays.map((x) => x.Date)}
                            onDayClick={this.handleDayClick}
                            renderDay={this.renderDay}
                            disabledDays={[{ before: new Date() }]}
                        />
                    </div>
                </div>
                {this.state.openCalendarInput && (
                    <CalendarInput
                        date={this.state.selectedDate}
                        handleCancel={() => this.setState({ openCalendarInput: false })}
                        handleSave={this.handleAddJob}
                        isEdit={this.state.isEdit}
                        jobs={this.state.selectedDateJobs}
                        Id={this.state.jobId}
                        isEmployeeSelected={this.state.employee ? true : false}
                        handleUpdate={this.handleUpdateJob}
                        handleRemove={(id) => this.setState({ selectedDays: this.state.selectedDays.filter((x) => x.Id !== id), openCalendarInput: false })}
                    />
                )}
                {this.state.openAddShiftDialog && (
                    <AddShiftTemplateDialog
                        isAccountTemplate
                        hierarchyId={HierarchySettingsStore.getGlobalLevelItemFilterId()}
                        handleClose={() => this.setState({ openAddShiftDialog: false })}
                        handleAdd={this.addShiftTemplate}
                        scheduleClient={this.props.client}
                        preventJobChange
                    />
                )}
                <ToolTip active={this.state.showTooltip} position="right" arrow="center" parent={"#employeeTooltip"}>
                    <div style={{ padding: 5, width: 200, overflowY: "auto", maxHeight: 300 }}>{dateWithMultipleJobsExist && <span>{strings.Employee_can_not_be_selected}</span>}</div>
                </ToolTip>
            </Dialog>
        )
    }
}

export default AddClientJobDialog
